import { useMemo } from 'react';
import useCustomCompareEffect from 'react-use/lib/useCustomCompareEffect';
import { useFirstMountState } from 'react-use/lib/useFirstMountState';

import { useSelector } from 'react-redux';
import { accountsSelectors } from '../../flux/accounts';

export const useExcludeFrom = (formik) => {
  const accountsById = useSelector(accountsSelectors.getAccountsById);
  const investmentTxnType =
    formik.values.investmentTxnType || (formik.values.type === 'CASH_FLOW' && 'VIRTUAL_CASH_FLOW');

  const ignoreIsDisabled = useMemo(() => {
    let isDisabled;
    switch (investmentTxnType) {
      case 'VIRTUAL_CASH_FLOW':
        isDisabled = false;
        break;
      default:
        isDisabled = true;
    }
    return isDisabled;
  }, [investmentTxnType]);

  const isFirstMount = useFirstMountState();
  useCustomCompareEffect(
    () => {
      if (!isFirstMount) {
        const selectedAccount = accountsById.get(formik.values.accountId);
        const excludeReports = investmentTxnType !== 'VIRTUAL_CASH_FLOW' || selectedAccount.isExcludedFromReports;
        const excludeF2S = investmentTxnType !== 'VIRTUAL_CASH_FLOW' || selectedAccount.isExcludedFromBudgets;
        if (formik.values.isExcludedFromReports !== excludeReports) {
          formik.setFieldValue('isExcludedFromReports', excludeReports);
        }
        if (formik.values.isExcludedFromF2S !== excludeF2S) {
          formik.setFieldValue('isExcludedFromF2S', excludeF2S);
        }
      }
    },
    [investmentTxnType, formik, isFirstMount],
    ([investmentTxnTypePrev], [investmentTxnTypeNext]) => investmentTxnTypePrev === investmentTxnTypeNext,
  );

  return ignoreIsDisabled;
};
export default useExcludeFrom;
